import { MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds/components/text";
import {
  StyledContainer,
  StyledExpandedContentContainer,
  StyledHeader,
  StyledHeaderLeft,
  StyledHeaderText,
  StyledIconWrapper,
} from "./configuration-list-row.style";
import {
  MDSConfigurationListRowProps,
  MDSConfigurationListRowSlotName,
} from "./configuration-list-row.types";
import { getSlot, getUnslottedChildren } from "@/mds/utils/slots";
import { MDSSeparator } from "@/mds/components/separator";

export const MDSConfigurationListRow = ({
  children,
  title,
  description,
  isExpanded = false,
}: MDSConfigurationListRowProps) => {
  const leftAddon = getSlot(children, MDSConfigurationListRowSlotName.LeftAddon);
  const rightAddon = getSlot(children, MDSConfigurationListRowSlotName.RightAddon);
  const expandedContent = getSlot(children, MDSConfigurationListRowSlotName.ExpandedContent);
  const buttonsBottom = getSlot(children, MDSConfigurationListRowSlotName.ButtonsBottom);

  return (
    <StyledContainer>
      <StyledHeader>
        <StyledHeaderLeft>
          <StyledIconWrapper>{leftAddon}</StyledIconWrapper>
          <StyledHeaderText>
            {typeof title === "string" ? (
              <MDSText variant={MDSTextVariant.TextS} weight={MDSTextWeight.Smedium}>
                {title}
              </MDSText>
            ) : (
              title
            )}
            {typeof description === "string" ? (
              <MDSText variant={MDSTextVariant.TextS} color={MDSTextColor.Secondary}>
                {description}
              </MDSText>
            ) : (
              description
            )}
          </StyledHeaderText>
        </StyledHeaderLeft>
        {rightAddon}
      </StyledHeader>

      {expandedContent && isExpanded && (
        <StyledExpandedContentContainer>
          <MDSSeparator orientation="horizontal" />
          {expandedContent}
        </StyledExpandedContentContainer>
      )}

      {getUnslottedChildren(children)}
      {buttonsBottom}
    </StyledContainer>
  );
};
